import axios, { AxiosResponse, AxiosError } from "axios";
import store from "../redux/store";
import { setError } from "../redux/actions/error";
import { clearAdminLogin } from "../redux/actions/adminLogin";
import { clearShopLogin } from "../redux/actions/shopLogin";
import { StoreState } from "./authService";

function getHeaders() {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  
  return headers;
}

// Get isUserAdmin from current state when needed
function isUserAdmin() {
  const state = store.getState() as StoreState;
  return state.login.isUserAdmin;
}

export const HttpRequestGet = (
  url: string,
  dispatch: Function,
  actionSuccess: Function,
  actionFailure: Function,
  withAuthentication: boolean,
  callback?: Function,
  errorCallback?: (err: AxiosResponse | undefined) => AxiosResponse
) => {
  const headers = getHeaders();

  axios
    .get(url, { 
      headers
    })
    .then((response: AxiosResponse) => {
      dispatch(actionSuccess(response.data));
      if (callback) callback(response.data);
    })
    .catch((error: AxiosError) => {
      dispatch(actionFailure(error.message));

      if (errorCallback && typeof errorCallback === "function") {
        errorCallback(error.response);
        return;
      }

      if (error.response?.status === 401) {
        if (isUserAdmin()) {
          dispatch(clearAdminLogin());
        } else {
          dispatch(clearShopLogin());
        }
      } else {
        if (error.response?.data === undefined) {
          dispatch(setError(error.message));
        } else {
          if (error.response?.data.Error !== undefined) {
            dispatch(setError(error.response?.data.Error));
          } else {
            dispatch(setError(error.response?.data));
          }
        }
      }
    });
};

export const HttpRequestPost = (
  url: string,
  dispatch: Function,
  actionSuccess: Function,
  actionFailure: Function,
  withAuthentication: boolean,
  requestBody: object,
  callback?: (responseData: AxiosResponse | undefined) => void,
  errorCallback?: (err: AxiosResponse | undefined) => AxiosResponse
) => {
  const headers = getHeaders();
  axios
    .post(url, requestBody, {
      headers
    })
    .then((response: AxiosResponse) => {
      dispatch(actionSuccess(response.data));
      if (callback) callback(response.data);
    })
    .catch((error: AxiosError) => {
      dispatch(actionFailure(error?.response?.data.Error));

      if (errorCallback && typeof errorCallback === "function") {
        errorCallback(error.response);
        return;
      }

      if (error.response?.status === 401) {
        if (isUserAdmin()) {
          dispatch(clearAdminLogin());
        } else {
          dispatch(clearShopLogin());
        }
      } else {
        if (error.response?.data === undefined) {
          dispatch(setError(error.message));
        } else {
          if (error.response?.data.Error !== undefined) {
            dispatch(setError(error.response?.data.Error));
          } else {
            dispatch(setError(error.response?.data));
          }
        }
      }
    });
};
export const HttpRequestPut = (
  url: string,
  dispatch: Function,
  actionSuccess: Function,
  actionFailure: Function,
  withAuthentication: boolean,
  requestBody: object
) => {
  const headers = getHeaders();
  axios
    .put(url, requestBody, {
      headers
    })
    .then((response: AxiosResponse) => {
      dispatch(actionSuccess(response.data));
    })
    .catch((error: AxiosError) => {
      dispatch(actionFailure(error.message));

      if (error.response?.status === 401) {
        if (isUserAdmin()) {
          dispatch(clearAdminLogin());
        } else {
          dispatch(clearShopLogin());
        }
      } else {
        if (error.response?.data === undefined) {
          dispatch(setError(error.message));
        } else {
          if (error.response?.data.Error !== undefined) {
            dispatch(setError(error.response?.data.Error));
          } else {
            dispatch(setError(error.response?.data));
          }
        }
      }
    });
};
export const HttpRequestPostForLogin = (
  url: string,
  dispatch: Function,
  actionSuccess: Function,
  actionFailure: Function,
  withAuthentication: boolean,
  requestBody: object
) => {
  const headers = getHeaders();
  axios
    .post(url, requestBody, {
      headers
    })
    .then((response: AxiosResponse) => {
      if (response.data.Result === "UserNotRegistered") {
        dispatch(
          actionFailure("Email address / password combination is incorrect")
        );
        dispatch(
          setError("~~Email address / password combination is incorrect~~")
        );
      } else {
        dispatch(actionSuccess(response.data));
      }
    })
    .catch((error: AxiosError) => {
      dispatch(actionFailure(error.response?.data));
      if (error.response?.data.Error !== undefined) {
        error.response?.data.Error === "UserNotRegistered"
          ? dispatch(
              setError("Email address / password combination is incorrect")
            )
          : dispatch(setError(error.response?.data.Error));
      } else {
        dispatch(setError(error.response?.data));
      }
    });
};

export const HttpRegularPost = (
  url: string,
  reqBody: any,
  thunkDetails?: {
    dispatch: any;
    actionSuccess: any;
    actionFailure?: any; // If action failure is not passed then it will display error message that comes from backend
    callback?: (resp?: any) => void;
  }
) => {
  const headers = getHeaders();

  if (thunkDetails) {
    const { dispatch, actionSuccess, actionFailure, callback } = thunkDetails;

    axios
      .post(url, reqBody, {
        headers
      })
      .then((response) => {
        dispatch(actionSuccess());
        if (callback) callback(response.data);
      })
      .catch((error) => {
        dispatch(
          actionFailure
            ? actionFailure()
            : setError(error?.response?.data?.Error ?? "Error Occured")
        );
      });
  } else {
    axios
      .post(url, reqBody, {
        headers
      })
      .then((response) => {
      })
      .catch((error) => {
      });
  }
};

export const HttpRegularPut = (
  url: string,
  reqBody: any,
  thunkDetails?: {
    dispatch: any;
    actionSuccess: any;
    actionFailure?: any; // If action failure is not passed then it will display error message that comes from backend
    callback?: any;
  }
) => {
  const headers = getHeaders();

  if (thunkDetails) {
    const { dispatch, actionSuccess, actionFailure, callback } = thunkDetails;

    axios
      .put(url, reqBody, {
        headers
      })
      .then((response) => {
        dispatch(actionSuccess());
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(
          actionFailure
            ? actionFailure()
            : setError(error?.response?.data?.Error ?? "Error Occured")
        );
      });
  } else {
    axios
      .put(url, reqBody, {
        headers
      })
      .then((response) => {
      })
      .catch((error) => {
      });
  }
};

export const HttpRegularDelete = (
  url: string,
  thunkDetails?: {
    dispatch: any;
    actionSuccess?: any;
    actionFailure?: any; // If action failure is not passed then it will display error message that comes from backend
    callback?: any;
  }
) => {
  const headers = getHeaders();

  if (thunkDetails) {
    const { dispatch, actionSuccess, actionFailure, callback } = thunkDetails;

    axios
      .delete(url, {
        headers
      })
      .then((response) => {
        actionSuccess && dispatch(actionSuccess());
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(
          actionFailure
            ? actionFailure()
            : setError(error?.response?.data?.Error ?? "Error Occured")
        );
      });
  } else {
    axios
      .delete(url, {
        headers
      })
      .then((response) => {
      })
      .catch((error) => {
      });
  }
};

export const HttpRegularGet = (
  url: string,
  callback?: Function,
  failCallback?: Function
) => {
  const headers = getHeaders();

  axios
    .get(url, { 
      headers
    })
    .then((response: AxiosResponse) => {
      if (callback) callback(response.data);
    })
    .catch((error: AxiosError) => {
      if (failCallback) failCallback();
    });
};

export const HttpRequestGetBlob = (
  url: string,
  callback: (resp: Blob) => void,
  failCallback: (err?: any) => void
) => {
  const headers = getHeaders();

  axios
    .get(url, { 
      headers,
      responseType: 'blob'
    })
    .then((response: AxiosResponse) => {
      if (callback) callback(response.data);
    })
    .catch((error: AxiosError) => {
      if (failCallback) failCallback(error);
    });
};